var cov_1wtnkjsh6r = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Input/index.ts",
      hash = "3c4e7e4840f66f55a7a4eb33708edec5f464cfd4",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Input/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 17,
          column: 8
        }
      },
      "1": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 80
        }
      },
      "2": {
        start: {
          line: 20,
          column: 0
        },
        end: {
          line: 24,
          column: 9
        }
      },
      "3": {
        start: {
          line: 26,
          column: 0
        },
        end: {
          line: 29,
          column: 11
        }
      },
      "4": {
        start: {
          line: 31,
          column: 0
        },
        end: {
          line: 31,
          column: 37
        }
      },
      "5": {
        start: {
          line: 32,
          column: 0
        },
        end: {
          line: 32,
          column: 50
        }
      },
      "6": {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 33,
          column: 54
        }
      },
      "7": {
        start: {
          line: 34,
          column: 0
        },
        end: {
          line: 34,
          column: 48
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { compose } from '../utils/func';
import inputable from '../Form/inputable';
import inputBorder from '../hoc/inputBorder';
import delay from '../hoc/delay';
import coin from '../hoc/coin';
import Input from './Input';
import Number from './Number';
import Group from './Group';
import Password from './Password';
var exports = (cov_1wtnkjsh6r.s[0]++, compose(inputable, inputBorder({}), delay(400), coin('input'))(Input));
cov_1wtnkjsh6r.s[1]++;
exports.Group = inputBorder({
  tag: 'div',
  isGroup: true,
  from: 'input'
})(Group);
cov_1wtnkjsh6r.s[2]++;
exports.Number = compose(inputable, inputBorder({}), coin())(Number);
cov_1wtnkjsh6r.s[3]++;
exports.Password = compose(inputable, inputBorder({}))(Password);
cov_1wtnkjsh6r.s[4]++;
exports.displayName = 'ShineoutInput';
cov_1wtnkjsh6r.s[5]++;
exports.Number.displayName = 'ShineoutInputNumber';
cov_1wtnkjsh6r.s[6]++;
exports.Password.displayName = 'ShineoutInputPassword';
cov_1wtnkjsh6r.s[7]++;
exports.Group.displayName = 'ShineoutInputGroup';
export default exports;